React = require 'react'

MuteButton = React.createClass
  propTypes:
    title: React.PropTypes.string

  getInitialState: ->
    muted: @props.initialMuted

  handleClick: (event) ->
    newState = !@state.muted
    @setState muted: newState
    @props.callbackParent newState

  render: ->
    mute_text = if @state.muted then 'volume_up' else 'volume_off'

    React.createElement("div", {"className": "mute-button"},
      React.createElement("a", {"className": 'text-decoration-none mdl-button mdl-js-button mdl-button mdl-js-ripple-effect mdl-button--fab mute-toggle-button', "onClick": (@handleClick)}, React.createElement("i", {"className": "material-icons md-light"}, (mute_text)))
    )

module.exports = MuteButton



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./app/components/MuteButton.cjsx
 **/